import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Form, Input, Button, Checkbox, Card, Alert, Spin } from "antd";

import validators from "../../validators/validators";
import { FormInputField } from "../FormInputField/FormInputField";

import * as userActions from "../../actionCreators/User";

import "./LoginForm.css";

const LoginForm = ({ logIn, error, history }) => {
  const [loading, setLoading] = useState(false);
  const [elementFocused, setElementFocused] = useState(false);

  const [rememberme, setRememberme] = useState(false);
  const handleSubmitForm = async (values, actions) => {
    setLoading(true);
    values["rememberme"] = rememberme;
    logIn(values, history);
  };

  return (
    <Card className={"LoginFormCard"}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          textAlign: "left",
          marginBottom: "30px",
        }}
      >
        Sign in to start your session
      </p>
      <div style={{ textAlign: "center", margin: "1%" }}></div>
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={validators.user.loginSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmitForm(values, actions)}
        render={(formikProps) => {
          const { errors, isSubmitting, handleSubmit } = formikProps;
          return (
            <>
              {Object.keys(errors).length > 0 && (
                <Alert
                  message={errors.email || errors.password || errors.auth}
                  type="error"
                  showIcon
                  style={{ marginBottom: "1.05rem", maxWidth: "410px" }}
                />
              )}
              {error && (
                <Alert
                  message={error}
                  type="error"
                  showIcon
                  className="column-error"
                />
              )}
              {loading && !error ? (
                <div className="spin-loader" style={{ marginTop: "-150px" }}>
                  <Spin size="large" />
                </div>
              ) : (
                <Form onFinish={handleSubmit}>
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    name="email"
                    labelText="Email"
                    className="text-field"
                    hideErrorMessage={true}
                    onSelect={()=>{setElementFocused(true)}}
                    readOnly={!elementFocused}
                  />
                  <Field
                    InputType={Input.Password}
                    component={FormInputField}
                    name="password"
                    labelText="Password"
                    className="text-field"
                    type="password"
                    hideErrorMessage={true}
                    onSelect={()=>{setElementFocused(true)}}
                    readOnly={!elementFocused}
                  />
                  <div
                    style={{
                      color: "#757575",
                      fontSize: 12,
                      marginBottom: 20,
                      fontWeight: 400,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      history.push("/forgot-password");
                    }}
                  >
                    Forgot Password?
                  </div>
                

                  <Checkbox
                    value={rememberme}
                    onChange={() => {
                      setRememberme(!rememberme);
                    }}
                  >
                    Remember Me
                  </Checkbox>
                  <Form.Item className="login-button-section">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className={"loginFormButton"}
                    >
                      LOGIN
                    </Button>
                   
                    <div style={{ textAlign: "center", margin: "1%" }}></div>
                  </Form.Item>
                  <div
                    style={{
                      color: "#757575",
                      fontSize: 13,
                      // marginBottom: 20,
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      history.push("/privacy-policy");
                    }}
                  >
                    Privacy Policy
                  </div>
                </Form>
              )}
            </>
          );
        }}
      />
    </Card>
  );
};

const mapStateToProps = ({
  user: {
    currentUser: { error },
  },
}) => ({ error });

const mapDispatchToProps = (dispatch) => ({
  logIn: bindActionCreators(userActions.logIn, dispatch),
});

LoginForm.propTypes = {
  user: PropTypes.object,
  logIn: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      redirectUrl: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
